/**
 * DiscountCampaignsCtrl controller
 */
/**
 * DiscountCampaignsCtrl controller
 *
 * @class DiscountCampaignsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:DiscountCampaignsCtrl
 */
/* @ngInject */
export default function DiscountCampaignsCtrl ($scope, $uibModal, $location, DiscountCampaign, NetworkCurrency, pckg, authSvc) {
  var vm = this
  NetworkCurrency.loadAll({ network: pckg }).then(res => {
    const currencies = res.filter(cur => cur.enabled)
    vm.defaultCurrency = currencies.length ? currencies[0].name : ''
  })

  vm.discount_campaign_statuses = {
    UPCOMING: 'Upcoming',
    EXPIRED: 'Expired',
    ACTIVE: 'Active'
  }

  vm.pastDiscounts = $location.url().includes('past-discounts')
  vm.hasAccess = function (access) {
    return authSvc.hasAccess(access)
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:DiscountCampaignsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg
  const networkId = vm.pckg.id

  /**
   * Get Discount Campaigns from backend
   *
   * @memberof mwApp/packages.controller:DiscountCampaignsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getDiscountCampaigns = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }
    if (vm.pastDiscounts) {
      tableState.search = { ...tableState.search, predicateObject: { ...tableState.search.predicateObject, past: true } }
    }
    DiscountCampaign.loadSmart(tableState, { networkId, past: vm.pastDiscounts })
      .then(
        data => {
          vm.discountCampaigns = data.content.map(c => (new DiscountCampaign({ ...c, networkId })))
          vm.issFound = !!vm.discountCampaigns.length
          vm.tableState = tableState
          $scope.loading = false
        }
      )
  }

  /**
   * Delete Discount Campaign
   *
   * @memberof mwApp/discountCampaign.controller:DiscountCampaignsCtrl
   */
  vm.delete = function (dc) {
    dc._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }
}
